import * as React from 'react';
import { connect } from 'react-redux';
import { isNil } from 'lodash';

import { resetContentFilters, updateContentFilters } from '../../../reducers/content';
import { trackEventDiscoveryContentFilters } from 'modules/tracking/utils/tracking';

import { getBrandProfileId } from 'utils/organization';
import { CHANNEL } from '../../../utils/content';
import { prepareFiltersForAnalytics } from '../../../utils/tracking';

import type { DiscoveryContentFilters, Organization } from 'types';

type OwnProps = {
  children: React.ReactNode,
  onResetFilters: () => void
};

type StateProps = {
  org: Organization,
  filters: DiscoveryContentFilters,
  lastStateReset: number
};

type DispatchProps = {
  dispatchUpdateFilters: (a: any) => Promise<void>,
  dispatchResetFilters: () => Promise<void>
};

type Props = OwnProps & StateProps & DispatchProps;

class DiscoveryContentFiltersStateHandler extends React.PureComponent<Props> {
  handleFiltersUpdate = (updatedFilters: any): void => {
    const { dispatchUpdateFilters } = this.props;

    dispatchUpdateFilters(updatedFilters)
      .then(() => this.handleFetchContent());

    this.handleEvents(updatedFilters);
  };

  handleFiltersReset = (): void => {
    const { dispatchResetFilters } = this.props;

    dispatchResetFilters()
      .then(() => this.handleFetchContent());
  };

  handleFetchContent(): void {
    const { onResetFilters } = this.props;

    onResetFilters();
  }

  handleEvents(updatedFilters: any): void {
    const { org } = this.props;
    const brandProfileId = getBrandProfileId(org);
    const preparedAnalyticsFilters = prepareFiltersForAnalytics(updatedFilters);

    if (brandProfileId) {
      trackEventDiscoveryContentFilters(org.id, brandProfileId, preparedAnalyticsFilters);
    }
  }

  render(): React.ReactNode {
    const { filters, children, lastStateReset } = this.props;

    return (
      <div className="discovery-creators-state-handler">
        {
          React.Children.map(children, child => {
            if (isNil(child) || !React.isValidElement(child)) {
              return null;
            }

            return React.cloneElement(child, {
              filters,
              channel: CHANNEL,
              lastStateReset,
              handleFiltersUpdate: this.handleFiltersUpdate,
              handleFiltersReset: this.handleFiltersReset
            }, null);
          })
        }
      </div>
    );
  }
}

const mapStateToProps = ({ organizations, discoveryContent }): StateProps => ({
  org: organizations.currentOrganization,
  filters: discoveryContent.filters,
  lastStateReset: discoveryContent.lastStateReset
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchUpdateFilters: (updatedFilters: any): Promise<void> => dispatch(updateContentFilters(updatedFilters)),

  dispatchResetFilters: () => (
    dispatch(resetContentFilters())
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(DiscoveryContentFiltersStateHandler);
